/**
 * @since 2026-04-21
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React from "react";
import "./StatusText.scss";

const DEFAULT_LABELS = {
  ok: "OK",
  info: "OK",
  warn: "WARN",
  error: "ERROR",
  validated: "VALIDATED",
  overridden: "VALIDATED",
  fullyValidated: "VALIDATED",
  na: "N/A",
  running: "RUNNING",
  queued: "QUEUED",
};

const StatusText = ({ severity = "ok", label, size = "default", suffix, className = "" }) => {
  const sev = severity || "ok";
  const displayLabel =
    label !== undefined && label !== null ? String(label).toUpperCase() : DEFAULT_LABELS[sev] || sev.toUpperCase();

  const classes = [
    "statusText",
    `statusText--${sev}`,
    size === "large" ? "statusText--overall" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes}>
      {displayLabel}
      {suffix && <span className="statusText__suffix">{suffix}</span>}
    </span>
  );
};

export default StatusText;
